var map = {
	"./icon-化学-normal@2x.png": "70a2",
	"./icon-化学-press@2x.png": "cc96",
	"./icon-历史-normal@2x.png": "18a2",
	"./icon-历史-press@2x.png": "cf58",
	"./icon-地理-normal@2x.png": "47bc",
	"./icon-地理-press@2x.png": "418a",
	"./icon-思想政治-normal@2x.png": "99ec",
	"./icon-思想政治-press@2x.png": "18fc",
	"./icon-技术-normal@2x.png": "0d69",
	"./icon-技术-press@2x.png": "730d",
	"./icon-政治-normal@2x.png": "28d5",
	"./icon-政治-press@2x.png": "44ff",
	"./icon-数学-normal@2x.png": "949f",
	"./icon-数学-press@2x.png": "ced7",
	"./icon-文科数学-normal@2x.png": "e922",
	"./icon-文科数学-press@2x.png": "a8dd",
	"./icon-物理-normal@2x.png": "4ac5",
	"./icon-物理-press@2x.png": "0eeb",
	"./icon-理科数学-normal@2x.png": "8aee",
	"./icon-理科数学-press@2x.png": "d47a",
	"./icon-生物-normal@2x.png": "a55f",
	"./icon-生物-press@2x.png": "43928",
	"./icon-生物学-normal@2x.png": "c383d",
	"./icon-生物学-press@2x.png": "8e67",
	"./icon-英语-normal@2x.png": "2dec",
	"./icon-英语-press@2x.png": "7baa",
	"./icon-语文-normal@2x.png": "e869",
	"./icon-语文-press@2x.png": "1df6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04f1";